'use strict';

var React = require('react');
var PropTypes = require('prop-types');
var cx = require('classnames');
var CLOSE = require('@arrive/ui-icons/svg/ic_close.svg');
var Select = require('react-select');
var ReactHighlight = require('react-highlight-words');
var listPopover = require('@arrive/list-popover');
var SVGIcon = require('@arrive/svg-icon');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);
var cx__default = /*#__PURE__*/_interopDefaultLegacy(cx);
var CLOSE__default = /*#__PURE__*/_interopDefaultLegacy(CLOSE);
var Select__default = /*#__PURE__*/_interopDefaultLegacy(Select);
var ReactHighlight__default = /*#__PURE__*/_interopDefaultLegacy(ReactHighlight);
var SVGIcon__default = /*#__PURE__*/_interopDefaultLegacy(SVGIcon);

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var styles = {"ethanol":"#fff","tandem":"#f4f5f5","chrome":"#d4d6d9","LFGray":"#9ea2a9","smokey":"#60646c","burnout":"#46494f","roadhog":"#303236","axle":"#1d1e20","grease":"#0a0a0b","bandit":"#e0f3fb","bigSky":"#b1e1f5","arrive":"#2aaae2","blueBayou":"#039ddd","nightTime":"#007dbc","blueridge":"#0062c0","gasoline":"#feefcb","diesel":"#f1ae11","mileMarker":"#e8f5e9","gatorguts":"#4caf50","frogger":"#2b731a","whoaNelly":"#ffedf1","jackknife":"#cb2024","icon":"arrive_SearchableDropdown__icon","listItem":"arrive_SearchableDropdown__listItem","focused":"arrive_SearchableDropdown__focused","searchedText":"arrive_SearchableDropdown__searchedText","container":"arrive_SearchableDropdown__container","containerFocused":"arrive_SearchableDropdown__containerFocused","selectedValue":"arrive_SearchableDropdown__selectedValue","removeIcon":"arrive_SearchableDropdown__removeIcon"};

var _excluded = ["isFocused", "selectProps", "innerRef"],
    _excluded2 = ["options", "value", "onChange", "inputValue", "onInputChange", "components", "selectStyles"];

var WrappedListItem = function WrappedListItem(_ref) {
  var data = _ref.data,
      isFocused = _ref.isFocused,
      innerProps = _ref.innerProps,
      selectProps = _ref.selectProps;
  var inputVal = selectProps.inputValue;
  return /*#__PURE__*/React__default["default"].createElement(listPopover.PopoverListItem, _extends({
    "data-testid": "option-".concat(data.value),
    className: cx__default["default"](styles.listItem, data.className, _defineProperty({}, styles.focused, isFocused))
  }, innerProps, {
    keepIconSpace: true,
    showIcon: !!data.icon,
    iconClass: cx__default["default"](styles.icon, data.iconClassName),
    icon: data.icon
  }), /*#__PURE__*/React__default["default"].createElement(ReactHighlight__default["default"], {
    highlightClassName: styles.searchedText,
    searchWords: [inputVal],
    textToHighlight: data.label
  }), data.node && data.node);
};

var ControlOverride = function ControlOverride(_ref2) {
  var isFocused = _ref2.isFocused,
      selectProps = _ref2.selectProps,
      innerRef = _ref2.innerRef,
      rest = _objectWithoutProperties(_ref2, _excluded);

  return /*#__PURE__*/React__default["default"].createElement("div", {
    "data-testid": "select-dropdown",
    onClick: selectProps.onClick,
    tabIndex: "-1",
    onBlur: selectProps.onBlur,
    onMouseEnter: selectProps.onMouseEnter,
    onMouseLeave: selectProps.onMouseLeave,
    ref: innerRef,
    className: cx__default["default"](styles.container, _defineProperty({}, styles.containerFocused, isFocused))
  }, selectProps.prefix, /*#__PURE__*/React__default["default"].createElement(Select.components.Control, _extends({
    isFocused: isFocused
  }, rest)), selectProps.suffix);
};

var preventDefaultFunc = function preventDefaultFunc(evt) {
  evt.preventDefault();
  evt.stopPropagation();
};

var DisplayValueOverride = function DisplayValueOverride(props) {
  // removeProps only exists when `isMulti` is true so replicate the same behavior for single select
  var removeProps = props.removeProps || {
    onClick: props.clearValue,
    onMouseDown: preventDefaultFunc,
    onTouchEnd: props.clearValue
  };
  return /*#__PURE__*/React__default["default"].createElement("div", _extends({
    className: styles.selectedValue
  }, removeProps), props.children, /*#__PURE__*/React__default["default"].createElement(SVGIcon__default["default"], {
    className: styles.removeIcon,
    svgRef: CLOSE__default["default"]
  }));
};

var SearchableDropdownContent = function SearchableDropdownContent(props) {
  var dropdownRef = React.useRef();

  var _useState = React.useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      menuIsOpen = _useState2[0],
      setMenuIsOpen = _useState2[1];

  var _useState3 = React.useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      mouseIn = _useState4[0],
      setMouseIn = _useState4[1];

  var handleClick = function handleClick() {
    setMenuIsOpen(!menuIsOpen);
    dropdownRef.current.focus();
  };

  var handleChange = function handleChange(e) {
    if (props.closeMenuOnSelect) {
      setMenuIsOpen(false);
    }

    if (props.selectOption) {
      props.selectOption(e);
    }
  };

  var handleBlur = function handleBlur() {
    if (!mouseIn) {
      setMenuIsOpen(false);
    }
  };

  var handleMouseLeave = function handleMouseLeave() {
    setMouseIn(false);
  };

  var handleMouseEnter = function handleMouseEnter() {
    setMouseIn(true);
  };

  return /*#__PURE__*/React__default["default"].createElement(Select__default["default"], _extends({
    onChange: function onChange(e) {
      return handleChange(e);
    },
    onClick: handleClick,
    onMouseLeave: handleMouseLeave,
    onMouseEnter: handleMouseEnter,
    onBlur: handleBlur,
    menuIsOpen: menuIsOpen,
    ref: dropdownRef
  }, props));
};

var SearchableDropdown = /*#__PURE__*/React__default["default"].forwardRef(function (_ref3, ref) {
  var options = _ref3.options,
      value = _ref3.value,
      onChange = _ref3.onChange,
      inputValue = _ref3.inputValue,
      onInputChange = _ref3.onInputChange,
      components = _ref3.components,
      selectStyles = _ref3.selectStyles,
      rest = _objectWithoutProperties(_ref3, _excluded2);

  var overrideComponents = _objectSpread2({
    DropdownIndicator: null,
    ClearIndicator: null,
    Option: WrappedListItem,
    Control: ControlOverride,
    MultiValue: DisplayValueOverride,
    SingleValue: DisplayValueOverride
  }, components);

  return /*#__PURE__*/React__default["default"].createElement(SearchableDropdownContent, _extends({
    selectOption: onChange,
    ref: ref,
    value: value,
    inputValue: inputValue,
    onInputChange: onInputChange,
    components: overrideComponents,
    options: options,
    hideSelectedOptions: true,
    isSearchable: true,
    backspaceRemovesValue: true,
    styles: _objectSpread2(_objectSpread2({}, selectStyles), {}, {
      control: function control(base) {
        var overrides = selectStyles && selectStyles.control ? selectStyles.control(base) : {};
        return _objectSpread2(_objectSpread2({}, base), {}, {
          border: 'none',
          borderRadius: 0,
          boxShadow: 'none',
          fontSize: '18px',
          flex: 1,
          alignItems: 'stretch'
        }, overrides);
      },
      placeholder: function placeholder(base) {
        return _objectSpread2(_objectSpread2({}, base), {}, {
          color: styles.smokey
        });
      }
    }),
    theme: function theme(_theme) {
      return _objectSpread2(_objectSpread2({}, _theme), {}, {
        borderRadius: 3,
        spacing: _objectSpread2(_objectSpread2({}, _theme.spacing), {}, {
          controlHeight: 50,
          menuGutter: 0
        })
      });
    }
  }, rest));
});
var valuePropType = PropTypes__default["default"].shape({
  value: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number]).isRequired,
  label: PropTypes__default["default"].string.isRequired,
  node: PropTypes__default["default"].node,
  className: PropTypes__default["default"].string,
  icon: PropTypes__default["default"].object,
  iconClassName: PropTypes__default["default"].string
});
SearchableDropdown.propTypes = {
  options: PropTypes__default["default"].arrayOf(PropTypes__default["default"].shape({
    /**
     * the unique id for each item
     * */
    value: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number]).isRequired,

    /**
     * the text that will be displayed when the item is selected
     */
    label: PropTypes__default["default"].string.isRequired,

    /**
     * an optional node that may contain supplemental information to display to the right of the label
     */
    node: PropTypes__default["default"].node,

    /**
     * an optional override to option's parent styling
     */
    className: PropTypes__default["default"].string,

    /**
     * optional svg that will be displayed on the left hand side in each item row
     */
    icon: PropTypes__default["default"].object,

    /**
     * optional class to adjust the option's icon styling.
     */
    iconClassName: PropTypes__default["default"].string
  })).isRequired,
  value: PropTypes__default["default"].oneOfType([valuePropType, PropTypes__default["default"].arrayOf(valuePropType)]),
  onChange: PropTypes__default["default"].func,
  inputValue: PropTypes__default["default"].string,
  onInputChange: PropTypes__default["default"].func,

  /**
   * react node that is rendered before the input area -- the default styling for icons is already included
   */
  prefix: PropTypes__default["default"].node,

  /**
   * react node that is rendered after the input area -- this has no default styles
   */
  suffix: PropTypes__default["default"].node,

  /**
   * This is an object of any additional overrides that you want to pass through to react-select
   */
  components: PropTypes__default["default"].object,

  /**
   * An object with a selection of keys that represent a subset of styleable react-select attributes. Read more: https://react-select.com/styles
   */
  selectStyles: PropTypes__default["default"].shape({
    container: PropTypes__default["default"].func,
    control: PropTypes__default["default"].func,
    placeholder: PropTypes__default["default"].func,
    singleValue: PropTypes__default["default"].func,
    valueContainer: PropTypes__default["default"].func
  })
};

module.exports = SearchableDropdown;
